
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/raw-food-subscription",
      function () {
        return require("private-next-pages/raw-food-subscription/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/raw-food-subscription"])
      });
    }
  